import React, { useEffect, useState } from 'react';
import { INTERNAL_ORDER_MASTER_BULK_UPLOAD, INTERNAL_ORDER_MASTER_BULK_DOWNLOAD } from '../../api/endpoints';

import UploadCSVFilesTable from '../../components/UploadCSVFilesTable/UploadCSVFilesTable';
import MastersTabBar from '../../components/Common/MastersTabBar/MastersTabBar';

const IOMasterUploadFiles = () => {

    const defaultData = [
        { key: '1', title: 'Internal Order Master', fileName: 'internal_order_master.csv' },
     ];


    return (
        <div className="px-6 pt-3">
            <MastersTabBar activeId="internalOrderMaster" />
            <UploadCSVFilesTable defaultData={defaultData} uploadApi = {INTERNAL_ORDER_MASTER_BULK_UPLOAD} downloadApi ={INTERNAL_ORDER_MASTER_BULK_DOWNLOAD}/>
        </div>
    )

}

export default IOMasterUploadFiles;